import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { switchMap } from 'rxjs/operators';
import { LoaderService } from 'src/app/services/loader.service';
import { PaymentReceiptService } from 'src/app/services/payment-receipt.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-faild',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.css']
})
export class FailedComponent implements OnInit {

  isCompleted: boolean = false;
  check: any;
  id: number; // Идентификатор транзакции

  mailForm = this.fb.group({
    email: [null, [Validators.required, Validators.email]]
  });
  // глобальные параметры валюты приложения
  globalLocation = environment.globalLocation;
  globalCurrencyCode = environment.globalCurrencyCode;

  constructor(private route: ActivatedRoute,
    private translate: TranslateService,
    private fb: FormBuilder,
    public snackBar: MatSnackBar,
    private checkSrv: PaymentReceiptService,
    private loaderService: LoaderService,
    private transactionSrv: TransactionService,) { }

  ngOnInit(): void {
    this.load();
  }

    // convenience getter for easy access to form fields
    get f() { return this.mailForm.controls; }

  load() {
    this.route.paramMap.pipe(
      switchMap(params => params.getAll('id'))
    )
      .subscribe(data => this.id = +data);
    this.getCheck();
  }

  getCheck() {
    this.isCompleted = false;

    this.transactionSrv.get(this.id.toString()).subscribe(
      data => {
        this.check = data;
      },
      error => {
        let message = this.translate.instant('an-error-occurred-while-processing');
        this.openSnackBar(message, 'x');
      }
    ).add(() => { this.isCompleted = true });
  }

  sendToMail(): void {
    if (this.mailForm.valid) {
      this.loaderService.display(true);
      this.checkSrv.send(this.mailForm.controls['email'].value, this.id)
        .subscribe(
          data => {
            let message = this.translate.instant('email-succesfully-send');
            this.openSnackBar(message, 'x');
          },
          error => {

            if (error.status === 500) {
              let message = this.translate.instant('service-is-temporarily-unavailable');
              this.openSnackBar(message, 'x');
            }
            else {
              let message = this.translate.instant('an-error-occurred-while-processing');
              this.openSnackBar(message, 'x');
            }
          }
        ).add(() => {
          //http call ends
          this.loaderService.display(false);
        });
    }
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }

}
